// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import PictureTwoToneSvg from "@ant-design/icons-svg/lib/asn/PictureTwoTone";
import AntdIcon from "../components/AntdIcon";
const PictureTwoTone = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: PictureTwoToneSvg
    });
if (process.env.NODE_ENV !== "production") {
    PictureTwoTone.displayName = "PictureTwoTone";
}
export default /*#__PURE__*/ React.forwardRef(PictureTwoTone);
